export default "__VITE_ASSET__Bndtk_Yt__"